import { request } from "./request";

// 频道 old
// export const getChannel = () => {
//   return request({
//     url: "/api/getNewsChannels",
//     method: "get",
//   });
// };
export const getChannel = () => {
  return request({
    url: "/gjmsWeb/categories/queryNavbarList",
    method: "get",
  });
};

// old
// export const getList = (params) => {
//   return request({
//     url: "/api/getNewsList/",
//     method: "get",
//     data: params,
//   });
// };
// new
export const getList = (params) => {
  return request({
    url: "gjmsWeb/articles/queryPageByCategoryId",
    method: "get",
    withCredentials: true,
    data: params,
  });
};

// export const getView = (params) => {
//   return request({
//     url: "/api/getNews/",
//     method: "get",
//     data: params,
//   });
// };

export const getView = (params) => {
  return request({
    url: "/gjmsWeb/articles/queryArticleVo",
    method: "get",
    data: params,
  });
};

export const getRank = () => {
  return request({
    url: "/api/getDailyNews/",
    method: "get",
  });
};

export const getRelatedNews = (params) => {
  return request({
    url: "/api/getRelatedNews/",
    method: "get",
    data: params,
  });
};

// old
// export const getTonglan = (params) => {
//   return request({
//     url: "/api/getHeadline/",
//     method: "get",
//     data: params,
//   });
// };
// new
export const getTonglan = (params) => {
  return request({
    url: "/gjmsWeb/articles/queryFullByCategoryId",
    method: "get",
    data: params,
  });
};

export const getWechatConfig = (params) => {
  return request({
    url: "/camel/wx/createJsapiSignature",
    method: "get",
    data: params,
  });
};

export const getMalaToutiao = () => {
  return request({
    url: "/mala-toutiao",
    method: "get",
  });
};
